import { initConsoleObservable, ConsoleApiName } from '@datadog/browser-core';
export function trackConsoleError(errorObservable) {
  const subscription = initConsoleObservable([ConsoleApiName.error]).subscribe(consoleLog => errorObservable.notify(consoleLog.error));
  return {
    stop: () => {
      subscription.unsubscribe();
    }
  };
}
